<template>
  <div class="layer notranslate" :class="{requiredSelectLang: required}">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"></button>
      <h2 class="layerTitle">{{ locale.language_settings }}</h2>
      <ul class="countryList">
        <li v-for="ln in setting.lang.usableList" :key="ln.c"
          :class="{active: ln.c === setLang}">
          <input type="radio" :id="`lang_${ln.c}`"
            :value="ln.c"
            v-model="setLang"
            @click="touchLang(ln.c)"
            @change="close" >
          <label :for="`lang_${ln.c}`">
            <img :src="require(`@/assets/img/country/${ln.c}.svg`)" alt="ln.n">
            <span :style="ln.c === setLang && {...setStyle('productActivate', 'border-color'), ...setStyle('productActivate', 'color')}">
              {{ln.c === 'zh-TW' ? '繁體'
                : ln.c === 'zh-CN' ? '简体'
                : ln.n}}
            </span>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'required'
  ],
  computed: {
    setting () {
      return this.$store.getters['common/getSetting']
    },
    ln () {
      return this.$route.params.ln
    },
    setLang: {
      get () {
        return this.ln
      },
      set (ln) {
        this.$store.dispatch('common/setLang', ln)
        this.$store.commit('system/setLocale', ln)
        this.$emit('close')
      }
    },
    langName () {
      return this.setting.lang.info.find(x => x.c === this.setLang).n
    },
    requiredSelectLang () {
      return this.required ? 'requiredSelectLang' : ''
    },
    isStore () {
      return this.$route.name === 'store'
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
  },
  data () {
    return {
    }
  },
  methods: {
    touchLang (ln) {
      if (ln === this.ln) {
        this.close()
      }
    },
    setStyle (target, attr, alpha) {
      return this.pointColors(target, attr, alpha)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  padding-bottom: 60px;
}
.countryList {
  position: fixed;
  top: 50px;
  right: 0;
  min-width: 100px;
  max-height: calc(100% - 60px);
  font-family: $f-f-default;
  border: 1px solid rgba(0,0,0,0.1);
  border-top: none;
  border-right: none;
  overflow: auto;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  z-index: 1;
  li {
    font-size: 0;
    border-top: 1px solid rgba(0,0,0,0.1);
    background-color: $color-white;
    img {
      width: 24px;
      margin-right: 8px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
      font-size: 12px;
    }
    label {
      opacity: 0.6;
    }
    &.active {
      label {
        opacity: 1;
      }
    }
    input {
      position: absolute;
      left: -9999px;
      width: 1px;
      height: 1px;
      margin: -1px;
      overflow: hidden;
      opacity: 0;
    }
    label {
      display: block;
      padding: 5px;
    }
  }
}
.hiddenFlag {
  .countryList {
    label {
      padding: 8px;
    }
    img {
      display: none;
    }
  }
}
@media screen and (min-width: 768px) {
  .countryList {
    position: absolute;
    top: 100%;
    left: 15px;
    right: 15px;
    margin-top: -15px;
    max-height: 300px;
  }
  @media screen and (max-width: 1023px) {
    .countryList {
      left: 0;
      right: 0;
      width: auto;
      margin-top: -5px;
      min-width: 0;
      max-height: 500px;
      text-align: center;
      box-shadow: 0 5px 5px rgba(0,0,0,0.1);
      li {
        img {
          margin-right: 0;
        }
        span {
          display: block;
          margin-top: 2px;
        }
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .hiddenFlag {
    .countryList {
      label {
        padding: 10px 8px;
      }
    }
    .btnCountry {
      padding: 15px 0 15px 8px;
      img {
        display: none;
      }
    }
  }
}
</style>
